import { Route, Switch } from "react-router-dom"

import { Login } from "../components/login/LoginCard"
import { Profile } from "../components/profile/Profile"
import { Signup } from "../components/signup/SignupCard"
import { EditProfile } from "../components/profile/EditProfile"
import { CreatePost } from "../components/create/CreatePost"
import { Temp } from "../components/profile/Temp"
import { TempPost } from "../components/profile/TempPost"
import Blogpage from "../components/Blogpage/Blogpage"
import LandingPage from "../components/Landing_page/LandingPage"
import { Bookmarks } from "../components/profile/Bookmarks"

import { HomePage } from "../components/front_page/homepage"

export const Routes = () => {
    return (
        <div>
            <Switch>
                <Route exact path="/">                   
                    <HomePage />
                </Route>
                {/* <Route exact path="/home">
             <LandingPage />
              
                </Route> */}
                {/* <Route exact path="/blogpage">
                 
                    <Blogpage/>
                </Route> */}
                <Route exact path="/signup">
                    <Signup/>
                </Route>
                <Route exact path="/login">
                    <Login/>
                </Route>
                <Route exact path="/users/:username">
                    <Profile/>
                </Route>
                <Route exact path="/settings">
                    <EditProfile/>
                </Route>
                <Route exact path="/create/">
                    <CreatePost/>
                </Route>
                <Route exact path="/homepage">
                    <Temp/>
                 </Route>
                <Route exact path="/posts/:id">
                    <TempPost/>
                </Route>
                <Route exact path="/bookmarks">
                    <Bookmarks/>
                </Route>
                <Route exact path="/home">
                    <Temp/>
                </Route>
                 <Route exact path="/notfound">
                    <h3>Page Not Found</h3>
                </Route>
            </Switch>
        </div>
    )
}